/*
 * The record banner's picture slot (decision 0616; T170). It sits on the banner's
 * navy gradient, so every colour here is the on-fill pair the banner already uses
 * and never a second palette. 💰 The contact column lived here too until
 * 2026-09-22, when the title bar standard took it off the banner.
 */

.wrap {
  --avatar-radius: calc(var(--avatar-size-banner) / 2);
  position: relative;
  display: inline-flex;
  flex: none;
}

/* The circle itself: the initials on the palette colour, or the photo filling it. */
.circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  overflow: hidden;
  width: var(--avatar-size-banner);
  height: var(--avatar-size-banner);
  border-radius: var(--radius-stadium);
  background: var(--avatar-fill, var(--surface-2));
  color: var(--on-avatar);
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
  line-height: 1;
  letter-spacing: 0.02em;
  user-select: none;
}

.initials {
  /* The letters centre on their cap height rather than on the line box, and the tracking's trailing space is given back. */
  transform: translateY(0.06em);
  margin-right: -0.02em;
}

.photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/*
 * The camera badge's slot: the Attendee Avatar's own ratios, so the badge's edge
 * lands on the circle's at the lower-right diagonal whatever the avatar's size
 * is. 🔨 The slot is the position and the size; the chrome and the hover belong
 * to the one icon button control (T178), which fills it.
 */
.badgeSlot {
  position: absolute;
  display: inline-flex;
  width: calc(var(--avatar-radius) * var(--avatar-badge-ratio) * 2);
  height: calc(var(--avatar-radius) * var(--avatar-badge-ratio) * 2);
  right: calc(var(--avatar-radius) * (1 - var(--avatar-badge-offset-ratio) * 0.7071) - var(--avatar-radius) * var(--avatar-badge-ratio));
  bottom: calc(var(--avatar-radius) * (1 - var(--avatar-badge-offset-ratio) * 0.7071) - var(--avatar-radius) * var(--avatar-badge-ratio));
}

/* The default avatar: the record type's glyph, centred in the same circle the
   picture fills. 🔨 It reads in the navy, not the on-avatar white: the circle's
   own fill with no palette colour behind it is the light surface, and white on
   that is a slot that looks empty. */
.glyph {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--navy-primary);
}
